import { Flex, freddyTheme } from '@coolblue-development/freddy';
import { CheckmarkCircled } from '@coolblue-development/icons';

export default function FilterIndicator() {
  return (
    <Flex
      color={freddyTheme.color.icon.sentimentPositive}
      sx={{
        alignSelf: 'flex-start',
        height: '1.2rem !important',
        transform: `translateX(calc(-1 * ${freddyTheme.spacing[100]}))`,
        svg: {
          width: '1.2rem !important',
          height: '1.2rem !important'
        }
      }}
    >
      <CheckmarkCircled size='small' innerFill='contrast' />
    </Flex>
  );
}
